import React, { useMemo, useState} from 'react';
import Layout from '../../Shared/Layout';
import {
    Collapse,
    Box,
    IconButton,
    makeStyles,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@material-ui/core";
import styled from "styled-components";
import { Inertia } from '@inertiajs/inertia'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import MuiButton from "@material-ui/core/Button";
import {Field, Form as FinalForm} from "react-final-form";
import {getCookieValue} from "../../utils/getCookieValue";
import { Trans } from "../../utils/i18n";
import dayjs from "dayjs";
import Paper from '@material-ui/core/Paper';
import SendIcon from '@mui/icons-material/Send';
import {Alert} from "@material-ui/lab";
import Wrapper from "./Wrapper";
import {Button, Modal, Tooltip} from "@mui/material";
import CloseIcon from "@material-ui/icons/Close";
import {ModalContent} from "../../Shared/ProductSelectDynamic";

const ActionRow = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
`;

const HR = styled.hr`
    display: flex;
    justify-content: flex-end;
    margin: 15px 0;
`;

const ResponseWrapper = styled.div`
    width: 100%;
    margin-top: 30px;
`;

const createConditionFilter = (values, state) => (fieldOrGroup, step) => {
    if (!fieldOrGroup.condition) {
        return true;
    }

    const paths =
        fieldOrGroup.condition.field
            .replace(/\[(.*)\]/gm, '.$1')
            .split('.');

    let value = paths.reduce((values, path) => values[path], values);

    if(fieldOrGroup.condition.compare === '!=') {
        if(value === undefined) {
            return null !== fieldOrGroup.condition.value;
        }
        return value !== fieldOrGroup.condition.value;
    }

    return value === fieldOrGroup.condition.value;
};

export default function History({ client, order, statuses, services, partners,
    coverages, settlements, materialOperations,
    files, userCanUpdate, orderattributes,
    orderhistories, extendedMode, permissions, returnUrl,
}) {
    const [formState, setFormState] = useState(undefined);
    const [response, setResponse] = useState(undefined);
    const [resendOrderitemHistory, setResendOrderitemHistory] = useState(null);

    const onSubmit = async (data) => {
        setFormState('loading');
        await fetch(route('queue.store'), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-XSRF-TOKEN': getCookieValue('XSRF-TOKEN'),
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({
                ...data,
                returnUrl,
            })
        })
            .then(res => res.json())
            .then(response => {
                if(response.success) {
                    setFormState('success');
                    setResponse('');
                    Inertia.visit(returnUrl || route('queue.index', { requesttype: order.requesttype_key }));
                    return
                }
                setResponse(response);
                setFormState('error');
            })
            .catch(() => {
                setFormState('error');
            })
    };

    const [openIds, setOpenIds] = React.useState([]);

    return (
        <Wrapper>
            {
                extendedMode && <HR/>
            }

            <FinalForm
                initialValues={order}
                onSubmit={onSubmit}>
                {({ handleSubmit, submitting, values, form, errors, touched }) => {

                    const currentStatus = statuses.find(item => item.id == values.status_id);
                    const currentService = services.find(item => item.id == values.service_id);
                    const currentSettlement = settlements.find(item => item.id == values.settlement_id);
                    const conditionFilter = useMemo(() => createConditionFilter(values), [values]);
                    let preFix = '';

                    return (
                        <form onSubmit={handleSubmit}>
                            {
                                extendedMode && orderhistories.length > 0 && <>
                                    <h3><Trans i18nKey="queueDetail.orderHistory">Order history</Trans></h3>

                                    <TableContainer component={Paper}>
                                        <Table size="small" aria-label={<Trans i18nKey="queueDetail.aDenseTable">a dense table</Trans>}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>
                                                    </TableCell>
                                                    <TableCell><Trans i18nKey="queueDetail.history.date">Date</Trans></TableCell>
                                                    <TableCell><Trans i18nKey="queueDetail.history.status">Status</Trans></TableCell>
                                                    <TableCell><Trans i18nKey="queueDetail.history.carrier">Carrier</Trans></TableCell>
                                                    <TableCell><Trans i18nKey="queueDetail.history.returnCarrier">Return carrier</Trans></TableCell>
                                                    <TableCell><Trans i18nKey="queueDetail.history.comment">Comment</Trans></TableCell>
                                                    <TableCell><Trans i18nKey="queueDetail.history.action">Action</Trans></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {orderhistories.map((item) => (
                                                    <>
                                                        <TableRow key={item.id}>
                                                            <TableCell>
                                                                <IconButton
                                                                    aria-label={
                                                                        <Trans i18nKey="queues.expandRow">
                                                                            expand row
                                                                        </Trans>
                                                                    }
                                                                    size="small"
                                                                    onClick={() => {
                                                                        if(openIds.includes(item.id)) {
                                                                            return setOpenIds(array => array.filter(arrayItem => arrayItem !== item.id));
                                                                        }
                                                                        setOpenIds(array => [...array, item.id]);
                                                                    }}
                                                                    // disabled={!product?.outgoingSerialnumbersList?.length}
                                                                >
                                                                    {openIds.includes(item.id) ? (
                                                                        <KeyboardArrowUpIcon />
                                                                    ) : (
                                                                        <KeyboardArrowDownIcon />
                                                                    )}
                                                                </IconButton>
                                                            </TableCell>
                                                            <TableCell component="th" scope="row">
                                                                {dayjs(item.updated_at).format('DD.MM.YYYY HH:mm')}
                                                            </TableCell>
                                                            <TableCell>{item.status}</TableCell>
                                                            <TableCell>
                                                                {item.carrier}<br />
                                                                {item.carrier_tracking_ref}
                                                            </TableCell>
                                                            <TableCell>
                                                                {item.return_carrier}<br />
                                                                {item.return_tracking_ref}
                                                            </TableCell>
                                                            <TableCell>{item.comment}</TableCell>
                                                            <TableCell>
                                                                {
                                                                    item.canResendNotification &&
                                                                    <Tooltip title={"Resend notification"}>
                                                                        <IconButton onClick={() => {
                                                                            setResendOrderitemHistory(item);
                                                                        }}>
                                                                            <SendIcon />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                }
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell style={{ paddingBottom: 0, paddingTop: 0, width: '100%', }} colSpan={10}>
                                                                <Collapse timeout="auto" unmountOnExit in={openIds.includes(item.id)}>
                                                                    <Box margin={1}>

                                                                        <ul>
                                                                            <li><b><Trans i18nKey="queueDetail.appointmentDate">Appointment date</Trans>:</b> {item.appointment_date && dayjs(item.appointment_date).format('DD.MM.YYYY HH:mm')}</li>
                                                                            <li><b><Trans i18nKey="queueDetail.history.collectionDate">Collection date</Trans>:</b> {item.collection_datetime && dayjs(item.collection_datetime).format('DD.MM.YYYY HH:mm')}</li>
                                                                            <li><b><Trans i18nKey="queueDetail.history.deliveryDate">Delivery date</Trans>:</b> {item.delivery_datetime && dayjs(item.delivery_datetime).format('DD.MM.YYYY HH:mm')}</li>
                                                                            <li><b><Trans i18nKey="queueDetail.history.collection">Pickup</Trans>:</b>
                                                                                {
                                                                                    item.pickup_number &&
                                                                                    <span>
                                                                                        {item.pickup_number}<br />
                                                                                        {dayjs(item.pickup_readytime).format('DD.MM.YY HH:mm')} - {dayjs(item.pickup_closetime).format('HH:mm')}
                                                                                    </span>
                                                                                }
                                                                            </li>
                                                                            <li><b><Trans i18nKey="queueDetail.history.exception">Exception</Trans>:</b> {item.exception}</li>
                                                                        </ul>
                                                                    </Box>
                                                                </Collapse>
                                                            </TableCell>
                                                        </TableRow>
                                                    </>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <HR/>
                                    {
                                        resendOrderitemHistory &&
                                        <Modal
                                            open={true}
                                            onClose={() => {
                                                setResendOrderitemHistory(null);
                                            }}
                                        >
                                            <div className={'bg-white p-4 w-full max-w-2xl top-1/3 absolute mx-auto  rounded-2xl left-1/2 transform -translate-x-1/2'}>
                                                <IconButton aria-label="delete" onClick={() => {
                                                    setResendOrderitemHistory(null);
                                                }}
                                                style={{
                                                    position: 'absolute',
                                                    top: '1.5rem',
                                                    right: '1.5rem',
                                                }}
                                                >
                                                    <CloseIcon />
                                                </IconButton>
                                                <div className={'flex flex-col gap-9'}>
                                                    <h2 className={'w-full text-center text-1xl font-bold mt-6 lg:mt-16 m-0'}>
                                                        <Trans i18nKey="queueDetail.resendNotification.h1">
                                                            Are you sure you want to resend the notification for this
                                                            order item?
                                                        </Trans>
                                                    </h2>
                                                    <div className={'flex flex-row justify-end gap-6'}>
                                                        <MuiButton
                                                            variant="contained"
                                                            onClick={() => {
                                                                setResendOrderitemHistory(null);
                                                            }}>
                                                            <Trans i18nKey="queueDetail.cancel">Cancel</Trans>
                                                        </MuiButton>
                                                        <MuiButton
                                                            variant="contained"
                                                            color={"secondary"}
                                                            onClick={() => {
                                                                Inertia.post(route('queue.orderhistory.resend', {
                                                                    orderhistory: resendOrderitemHistory,
                                                                    order: order.order_id
                                                                }), {}, {
                                                                    preserveState: false,
                                                                });
                                                            }}
                                                        >
                                                            <Trans i18nKey="queueDetail.resendNotification">
                                                                Resend notification
                                                            </Trans>
                                                        </MuiButton>
                                                    </div>
                                                </div>
                                            </div>
                                        </Modal>
                                    }
                                </>
                            }

                            <div className={'flex justify-end gap-3 mt-10'}>
                                {
                                    permissions.includes('queue_shipping_label') &&
                                    <MuiButton
                                        variant="contained"
                                        color={'primary'}
                                        disabled={submitting || currentStatus.key === 'created' || currentStatus.key === 'closed' || currentStatus.key === 'canceled'}
                                        href={route('queue.shippinglabel', { ordernumber: order.number })}
                                        target="_blank"
                                    >
                                        <Trans i18nKey="queueDetail.shippingLabelButton">CREATE SHIPPING LABEL</Trans>
                                    </MuiButton>
                                }
                                {
                                    extendedMode &&
                                    <MuiButton
                                        variant="contained"
                                        disabled={submitting}
                                        onClick={() => Inertia.visit(route('queue.index', { requesttype: order.requesttype_key }))}
                                    >
                                        <Trans i18nKey="queueDetail.cancel">Cancel</Trans>
                                    </MuiButton>
                                }
                                <MuiButton
                                    variant="contained"
                                    color={'secondary'}
                                    disabled={submitting || !userCanUpdate}
                                    type={'submit'}
                                    onClick={() => {
                                        form.change('saveAndCloseJob', false);
                                    }}
                                >
                                    <Trans i18nKey="queueDetail.save">Save</Trans>
                                </MuiButton>
                                {
                                    extendedMode == false &&
                                    <MuiButton
                                        variant="contained"
                                        color={'secondary'}
                                        disabled={submitting || !userCanUpdate || currentStatus.key === 'closed'}
                                        type={'submit'}
                                        onClick={() => {
                                            form.change('saveAndCloseJob', true);
                                        }}
                                    >
                                        <Trans i18nKey="queueDetail.saveAndClose">Save & close job</Trans>
                                    </MuiButton>
                                }
                                <br/>
                            </div>
                            <ResponseWrapper>
                                {
                                    response?.message && <Alert severity="warning">{ response?.message }</Alert>
                                }
                            </ResponseWrapper>
                        </form>
                    )
                }}
            </FinalForm>
        </Wrapper>
    )
}

History.layout = page => <Layout children={page} />;
